import { EMPTY_ARRAY, EMPTY_OBJECT } from 'constants/globalConstants';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export interface QueryOptions {
  consumer?: boolean;
  resetOnUnmount?: boolean;
  lazy?: boolean;
  params?: Record<string, any>;
  dependencies?: any[];
}

interface ConfigOptions extends QueryOptions {
  action: (...args: any) => void;
  resetAction?: (...args: any) => any;
  selector: (state: any) => any;
}

const useQuery = ({
  action,
  selector,
  resetAction,
  lazy = true,
  consumer = true,
  params = {},
  resetOnUnmount = true,
  dependencies = EMPTY_ARRAY,
}: ConfigOptions) => {
  const dispatch = useDispatch();
  const state = useSelector((state: any) =>
    consumer ? selector(state) : EMPTY_OBJECT,
  );

  const get = useCallback((...args: any) => dispatch(action(...args)), [
    action,
  ]);

  const reset = () => resetAction && dispatch(resetAction());

  useEffect(() => {
    if (!lazy) get(params);
    return () => resetOnUnmount && reset();
  }, [get, lazy, dependencies]);

  return { get, reset, ...state };
};

export default useQuery;
